import { useEffect } from 'react';
import { isValidNumber } from '@gp/utils/common';
import {
  queryActionItemsListResultType,
} from '@gp/types/projectUpdate.d';

function useActionItemsFilterList(props: {
  dataList: queryActionItemsListResultType['workplans'] | null,
  selectStatus: string[],
  selectPhase: string[],
  setRecords: React.Dispatch<React.SetStateAction<queryActionItemsListResultType['workplans']>>,
  paginationMsg: {
    pageIndex: number,
    pageSize: number,
    total: number,
  },
  setPaginationMsg: React.Dispatch<React.SetStateAction<{
    pageIndex: number;
    pageSize: number;
    total: number;
  }>>,
}) {
  const {
    dataList,
    selectStatus,
    selectPhase,
    setRecords,
    paginationMsg,
    setPaginationMsg,
  } = props;

  // 过滤筛选数据效果
  useEffect(() => {
    if (Array.isArray(dataList)) {
      const newRecords = dataList?.filter((t) => {
        const status = isValidNumber(t?.status) ? String(t?.status) : '';
        const isIncludeStatus = !selectStatus?.length || selectStatus?.includes(status);
        const isIncludePhase = !selectPhase?.length || selectPhase?.includes(t?.milestone_id);
        return isIncludeStatus && isIncludePhase;
      });
      setRecords(newRecords);
      setPaginationMsg({
        ...paginationMsg,
        total: newRecords?.length || 0,
      });
    }
  }, [
    dataList,
    selectStatus,
    selectPhase,
  ]);
}

export default useActionItemsFilterList;
